import { render, staticRenderFns } from "./SalesReport.vue?vue&type=template&id=709d52c2&scoped=true"
import script from "./SalesReport.vue?vue&type=script&lang=js"
export * from "./SalesReport.vue?vue&type=script&lang=js"
import style0 from "./SalesReport.vue?vue&type=style&index=0&id=709d52c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709d52c2",
  null
  
)

export default component.exports